export const dict = {
  en: {
    brand: "DentOrdu",
    programme: "Smile Ambassador Programme",
    tagline: "Share a Smile. Earn Rewards.",
    nav: {
      home: "Home", apply: "Apply", login: "Login", logout: "Logout",
      dashboard: "Dashboard", friends: "My Friends", rewards: "Rewards", academy: "Share & Earn Academy",
      admin: "Admin",
    },
    landing: {
      heroTitle: "Share a smile. Earn up to £1,800 in gift cards + a Turkey escape.",
      heroSub: "Join the DentOrdu Smile Ambassador Programme. Refer friends to our UK-friendly Turkey clinic — you focus on the friendship, we handle the dentistry.",
      applyCta: "Apply to become an Ambassador",
      loginCta: "I already have an account",
      howTitle: "How it works",
      howSteps: [
        { t: "Apply", d: "Submit your details. We review every application to keep the community authentic." },
        { t: "Share your link", d: "Get a personal referral link, ready-made messages and social templates from our Academy." },
        { t: "Earn rewards", d: "A £200 Amazon Gift Card for each of your first nine friends, a Turkey Escape at friend #10, plus a £15 bonus at each treatment plan." },
      ],
      rewardsTitle: "Ten friends. Ten rewards.",
      rewardsSub: "A £200 Amazon Gift Card for each of your first nine referrals — plus a Turkey Escape (5-night all-inclusive holiday for two) when your tenth friend qualifies. £15 bonus when your friend receives a treatment plan.",
      ambassadorsTitle: "Not a salesperson. A Smile Ambassador.",
      ambassadorsSub: "You share your personal connection. Medical assessment, treatment plans and pricing stay entirely with the clinic — where they belong.",
      footer: "© DentOrdu International. Reward eligibility subject to Programme Terms.",
    },
    apply: {
      title: "Apply to the programme",
      sub: "Tell us a little about yourself. Our team reviews every application within 3 working days.",
      firstName: "First name", surname: "Surname", email: "Email", phone: "Phone",
      country: "Country", message: "Anything you'd like us to know (optional)",
      submit: "Submit application",
      success: "Application submitted. We'll email you once reviewed.",
    },
    login: {
      title: "Welcome back", sub: "Log in to your Ambassador dashboard.",
      email: "Email", password: "Password", submit: "Log in", forgot: "Forgot password?",
      newHere: "New here? Apply to join →",
    },
    dashboard: {
      welcome: "Welcome back", awayFromNext: "successful referrals away from your next reward",
      totalFriends: "Total Friends Invited", activeReferrals: "Active Referrals",
      qualifiedReferrals: "Qualified Referrals", rewardsEarned: "Rewards Earned",
      nextReward: "Next Reward", currentLevel: "Current Level",
      progress: "of 10 Qualified Referrals",
      quickActions: "Quick actions",
      inviteFriend: "Invite a friend", copyLink: "Copy my referral link",
      shareWhatsapp: "Share on WhatsApp", sharingKit: "Open Sharing Toolkit",
      viewRewards: "View my rewards",
      recentFriends: "My friends",
      copiedToClipboard: "Referral link copied",
      viewAll: "View all",
    },
    friends: {
      title: "My friends", sub: "Track invitations and referrals. Statuses respect your friends' privacy.",
      addManual: "Add friend manually",
      empty: "You haven't invited anyone yet. Share your link or add a friend manually.",
      headers: { name: "Friend", added: "Added", status: "Status", reward: "Reward", source: "Source" },
      form: {
        title: "Add a friend", sub: "We'll contact them respectfully via their preferred channel.",
        firstName: "First name", lastName: "Last name", phone: "Phone", email: "Email (optional)",
        country: "Country", preferred: "Preferred contact",
        consent: "I confirm that this person has given me permission to share their contact details with DentOrdu International and has agreed to be contacted regarding dental treatment.",
        submit: "Add friend", cancel: "Cancel",
        success: "Friend added — we'll get in touch shortly.",
      },
    },
    rewards: {
      title: "Reward wallet",
      available: "Available", pending: "Pending", lifetime: "Lifetime",
      history: "Reward history",
      empty: "No rewards yet. Every qualified referral unlocks a new reward.",
      code: "Gift card code", booking: "Booking reference", credit: "Treatment credit ref",
      status: "Status",
      popupTitle: "Your gift card is on the way!",
      popupBody: "Your Amazon gift card code will be loaded to your account within 3 business days. We'll email you the code as soon as it's ready.",
      popupOk: "Great, thanks!",
      bonusTitle: "£15 Bonus unlocked",
      bonusHint: "This bonus is only awarded when your friend receives a treatment plan.",
    },
    academy: {
      title: "Share & Earn Academy",
      sub: "Ready-made messages, templates and rules — so you look great and stay compliant.",
      whatsapp: "WhatsApp", instagram: "Instagram", facebook: "Facebook", tiktok: "TikTok",
      guidelines: "Guidelines",
      copy: "Copy", copied: "Copied",
    },
    admin: {
      title: "Admin console",
      applications: "Applications", ambassadors: "Ambassadors", referrals: "Referrals",
      rewards: "Rewards", content: "Content", analytics: "Analytics", staff: "Staff",
      approve: "Approve", reject: "Reject", suspend: "Suspend", activate: "Activate",
      generatedPassword: "Generated password",
      shareWithApplicant: "Share this with the applicant — it will not be shown again. (Also emailed automatically.)",
      addStaff: "Add staff member",
      unassigned: "Unassigned",
      assignedTo: "Assigned staff",
    },
    statuses: {
      invitation_sent: "Invitation Sent",
      details_submitted: "Details Submitted",
      contact_confirmed: "Contact Confirmed",
      consultation_booked: "Consultation Booked",
      treatment_plan_prepared: "Treatment Plan Prepared",
      decision_pending: "Decision Pending",
      treatment_confirmed: "Treatment Confirmed",
      qualified_referral: "Qualified Referral",
      reward_approved: "Reward Approved",
      reward_sent: "Reward Sent",
      not_eligible: "Not Eligible",
    },
    publicRef: {
      title: "You've been invited",
      sub: "{name} thinks you'll love our free consultation. Leave your details — no obligation, no medical questions here.",
      consent: "I agree to be contacted by DentOrdu International about a free dental consultation.",
      submit: "Request my free consultation",
      thanks: "Thank you! Our team will be in touch soon.",
    },
    common: { close: "Close", save: "Save", cancel: "Cancel", back: "Back", loading: "Loading…" },
  },
  tr: {
    brand: "DentOrdu",
    programme: "Smile Ambassador Programı",
    tagline: "Bir gülüş paylaş. Ödül kazan.",
    nav: {
      home: "Ana Sayfa", apply: "Başvur", login: "Giriş", logout: "Çıkış",
      dashboard: "Panel", friends: "Arkadaşlarım", rewards: "Ödüller", academy: "Share & Earn Akademi",
      admin: "Yönetici",
    },
    landing: {
      heroTitle: "Bir gülüş paylaş. £1.800'e kadar hediye kartı + Türkiye tatili kazan.",
      heroSub: "DentOrdu Smile Ambassador Programı'na katıl. UK'lı arkadaşlarını Türkiye'deki kliniğimize yönlendir — sen dostluğa odaklan, dişçilik bize kalsın.",
      applyCta: "Ambassador olmak için başvur",
      loginCta: "Zaten hesabım var",
      howTitle: "Nasıl çalışır?",
      howSteps: [
        { t: "Başvur", d: "Bilgilerini gönder. Topluluğun kalitesi için her başvuruyu inceliyoruz." },
        { t: "Bağlantını paylaş", d: "Kişisel referans bağlantın ve hazır sosyal medya şablonları senin olsun." },
        { t: "Ödül kazan", d: "İlk 9 arkadaşın her biri için £200 Amazon Hediye Kartı, 10. arkadaşta Türkiye tatili, üstüne her tedavi planında £15 bonus." },
      ],
      rewardsTitle: "On arkadaş. On ödül.",
      rewardsSub: "İlk 9 yönlendirmenin her biri için £200 Amazon Hediye Kartı — 10. arkadaş uygun olduğunda iki kişilik 5 gece her şey dâhil Türkiye tatili. Arkadaşınıza tedavi planı sunulduğunda £15 bonus.",
      ambassadorsTitle: "Satış temsilcisi değil. Bir Smile Ambassador.",
      ambassadorsSub: "Sen sadece kişisel bağlantını paylaşırsın. Tıbbi değerlendirme, tedavi planı ve fiyatlandırma tamamen klinikte kalır.",
      footer: "© DentOrdu International. Ödül koşulları program şartlarına tabidir.",
    },
    apply: {
      title: "Programa başvur",
      sub: "Kendinden kısaca bahset. Her başvuru 3 iş günü içinde incelenir.",
      firstName: "Ad", surname: "Soyad", email: "E-posta", phone: "Telefon",
      country: "Ülke", message: "Bize iletmek istediğin bir şey var mı? (opsiyonel)",
      submit: "Başvuruyu gönder",
      success: "Başvurun alındı. İnceleme sonrası e-posta ile döneceğiz.",
    },
    login: {
      title: "Tekrar hoş geldin", sub: "Ambassador paneline giriş yap.",
      email: "E-posta", password: "Şifre", submit: "Giriş yap", forgot: "Şifremi unuttum",
      newHere: "Yeni misin? Başvur →",
    },
    dashboard: {
      welcome: "Tekrar hoş geldin", awayFromNext: "başarılı yönlendirme ile sonraki ödül",
      totalFriends: "Davet Edilen Arkadaş", activeReferrals: "Aktif Yönlendirme",
      qualifiedReferrals: "Uygun Yönlendirme", rewardsEarned: "Kazanılan Ödül",
      nextReward: "Sonraki Ödül", currentLevel: "Mevcut Seviye",
      progress: "/ 10 Uygun Yönlendirme",
      quickActions: "Hızlı işlemler",
      inviteFriend: "Arkadaş davet et", copyLink: "Referans bağlantımı kopyala",
      shareWhatsapp: "WhatsApp'ta paylaş", sharingKit: "Paylaşım Kitini aç",
      viewRewards: "Ödüllerimi gör",
      recentFriends: "Arkadaşlarım",
      copiedToClipboard: "Bağlantı kopyalandı",
      viewAll: "Tümünü gör",
    },
    friends: {
      title: "Arkadaşlarım", sub: "Davetler ve yönlendirmelerini takip et. Durumlar arkadaşının gizliliğine saygı gösterir.",
      addManual: "Manuel arkadaş ekle",
      empty: "Henüz kimseyi davet etmedin. Bağlantını paylaş veya manuel ekle.",
      headers: { name: "Arkadaş", added: "Eklendi", status: "Durum", reward: "Ödül", source: "Kaynak" },
      form: {
        title: "Arkadaş ekle", sub: "Tercih ettiği kanaldan saygılı bir şekilde iletişime geçeriz.",
        firstName: "Ad", lastName: "Soyad", phone: "Telefon", email: "E-posta (opsiyonel)",
        country: "Ülke", preferred: "Tercih edilen iletişim",
        consent: "Bu kişinin, iletişim bilgilerinin DentOrdu International ile paylaşılmasına ve diş tedavisi hakkında iletişime geçilmesine izin verdiğini onaylıyorum.",
        submit: "Arkadaşı ekle", cancel: "Vazgeç",
        success: "Arkadaş eklendi — yakında iletişime geçeceğiz.",
      },
    },
    rewards: {
      title: "Ödül cüzdanı",
      available: "Kullanılabilir", pending: "Bekleyen", lifetime: "Toplam",
      history: "Ödül geçmişi",
      empty: "Henüz ödül yok. Her uygun yönlendirme yeni bir ödül açar.",
      code: "Hediye kart kodu", booking: "Rezervasyon no", credit: "Tedavi kredi no",
      status: "Durum",
      popupTitle: "Hediye kartınız yolda!",
      popupBody: "Amazon hediye kart kodunuz 3 iş günü içinde hesabınıza yüklenecektir. Kod hazır olur olmaz size e-posta ile göndereceğiz.",
      popupOk: "Harika, teşekkürler!",
      bonusTitle: "£15 Bonus açıldı",
      bonusHint: "Bu bonus sadece arkadaşınıza tedavi planı sunulduğunda verilir.",
    },
    academy: {
      title: "Share & Earn Akademi",
      sub: "Hazır mesajlar, şablonlar ve kurallar — hem güzel görün hem kurallara uy.",
      whatsapp: "WhatsApp", instagram: "Instagram", facebook: "Facebook", tiktok: "TikTok",
      guidelines: "Kurallar",
      copy: "Kopyala", copied: "Kopyalandı",
    },
    admin: {
      title: "Yönetici konsolu",
      applications: "Başvurular", ambassadors: "Ambassadors", referrals: "Yönlendirmeler",
      rewards: "Ödüller", content: "İçerik", analytics: "Analitik", staff: "Personel",
      approve: "Onayla", reject: "Reddet", suspend: "Askıya al", activate: "Aktifleştir",
      generatedPassword: "Oluşturulan şifre",
      shareWithApplicant: "Bunu başvuru sahibiyle paylaşın — bir daha gösterilmeyecektir. (Ayrıca otomatik e-posta gönderildi.)",
      addStaff: "Personel ekle",
      unassigned: "Atanmamış",
      assignedTo: "Atanan personel",
    },
    statuses: {
      invitation_sent: "Davet Gönderildi",
      details_submitted: "Bilgiler Gönderildi",
      contact_confirmed: "İletişim Doğrulandı",
      consultation_booked: "Görüşme Planlandı",
      treatment_plan_prepared: "Tedavi Planı Hazırlandı",
      decision_pending: "Karar Bekleniyor",
      treatment_confirmed: "Tedavi Onaylandı",
      qualified_referral: "Ödüle Hak Kazandı",
      reward_approved: "Ödül Onaylandı",
      reward_sent: "Ödül Gönderildi",
      not_eligible: "Uygun Değil",
    },
    publicRef: {
      title: "Davet edildin",
      sub: "{name} ücretsiz konsültasyonumuzu seveceğini düşünüyor. Bilgilerini bırak — hiçbir tıbbi soru burada sorulmayacak.",
      consent: "DentOrdu International'ın ücretsiz diş konsültasyonu için benimle iletişime geçmesini kabul ediyorum.",
      submit: "Ücretsiz konsültasyon iste",
      thanks: "Teşekkürler! Ekibimiz yakında iletişime geçecek.",
    },
    common: { close: "Kapat", save: "Kaydet", cancel: "Vazgeç", back: "Geri", loading: "Yükleniyor…" },
  },
};
